import { render } from "./PackageStatusTag.vue?vue&type=template&id=404ce022&scoped=true&ts=true"
import script from "./PackageStatusTag.vue?vue&type=script&lang=ts"
export * from "./PackageStatusTag.vue?vue&type=script&lang=ts"

import "./PackageStatusTag.vue?vue&type=style&index=0&id=404ce022&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404ce022"]])

export default __exports__